<template>
  <div>
    <!-- Botón para abrir el diálogo, fuera del DialogPrime inicialmente -->
    <ButtonPrime 
      label="Ver Preguntas" 
      icon="pi pi-list" 
      class="p-button-info p-mb-3" 
      @click="showDialog = true"
    />

    <DialogPrime
      :visible="showDialog"
      @update:visible="showDialog = $event"
      header="Preguntas por Unidad y Capítulo"
      :modal="true"
      :style="{ width: '80vw' }"
    >
      <div class="p-d-flex p-flex-column p-ai-center">
        <h3 class="p-mb-3">Unidad: {{ idEjeTematico }} | Capítulo: {{ idCapitulo }}</h3>
        <div v-if="loading" class="p-text-center">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
          <p>Cargando preguntas...</p>
        </div>
        <div v-else-if="preguntas.length" class="table-container p-w-100">
          <DataTablePrime
            :value="preguntas"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20]"
            responsiveLayout="scroll"
            class="p-datatable-sm"
          >
            <ColumnPrime field="id_pregunta" header="ID Pregunta" sortable></ColumnPrime>
            <ColumnPrime field="Pregunta" header="Pregunta" sortable></ColumnPrime>
            <ColumnPrime field="Solucion" header="Solución"></ColumnPrime>
            <ColumnPrime field="ImagenPregunta" header="Imagen">
              <template #body="slotProps">
                <div class="image-container">
                  <img style="width:150px; heigth: 150px;" 
                    v-if="slotProps.data.ImagenPregunta"
                    :src="'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta"
                    alt="Imagen Pregunta"
                    
                    @error="slotProps.data.imageBroken = true"
                    @load="slotProps.data.imageBroken = false"
                  />
                  <span v-else class="no-image">Sin imagen</span>
                  <a
                    v-if="slotProps.data.ImagenPregunta"
                    :href="'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta"
                    target="_blank"
                    class="image-link"
                  >
                    {{ 'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta }}
                  </a>
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime header="Estado Imagen">
              <template #body="slotProps">
                <span v-if="!slotProps.data.ImagenPregunta">Sin imagen</span>
                <span v-else-if="slotProps.data.imageBroken === true" class="broken-image">Imagen no disponible</span>
                <span v-else-if="slotProps.data.imageBroken === false" class="valid-image">Imagen válida</span>
                <span v-else>Cargando...</span>
              </template>
            </ColumnPrime>
            <ColumnPrime field="Habilidad" header="Habilidad" sortable></ColumnPrime>
            <ColumnPrime field="Dificultad" header="Dificultad" sortable></ColumnPrime>
            <ColumnPrime field="IdVideo" header="ID Video" sortable></ColumnPrime>
            <ColumnPrime field="Alternativas" header="Alternativas"></ColumnPrime>
          </DataTablePrime>
        </div>
        <div v-else class="p-text-center">
          <p>No se encontraron preguntas para esta unidad y capítulo.</p>
        </div>
      </div>

      <template #footer>
        <ButtonPrime label="Cerrar" icon="pi pi-times" class="p-button-secondary" @click="showDialog = false" />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import DialogPrime from 'primevue/dialog';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ButtonPrime from 'primevue/button';
import axios from 'axios';

export default {
  name: 'PreguntasPorUnidadYCapituloDialog',
  components: {
    DialogPrime,
    DataTablePrime,
    ColumnPrime,
    ButtonPrime
  },
  props: {
    idEjeTematico: {
      type: Number,
      required: true
    },
    idCapitulo: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      preguntas: [],
      loading: false,
      showDialog: false // Estado interno para controlar la visibilidad
    };
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.fetchPreguntas();
      }
    }
  },
  methods: {
    async fetchPreguntas() {
      this.loading = true;
      this.preguntas = [];

      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/por-unidad-y-capitulo`, {
          params: {
            idEjeTematico: this.idEjeTematico,
            idCapitulo: this.idCapitulo
          }
        });
        this.preguntas = response.data;
        console.log('Preguntas cargadas:', this.preguntas);
      } catch (error) {
        console.error('Error al cargar preguntas:', error);
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las preguntas', life: 3000 });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  width: 100%;
}
.p-mb-3 {
  margin-bottom: 1rem;
}
</style>